import React, { PropTypes, PureComponent } from 'react';
import { toUrlData } from '../../../util/UrlParams';
import join from 'url-join';
import EmptyState from '../../../common/components/EmptyState';

export default class LoadGameRedirect extends PureComponent {
  static propTypes = {
    params: PropTypes.shape({
      gameId: PropTypes.string.isRequired
    }).isRequired
  };
  static defaultProps = {};

  static contextTypes = {
    dao: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  state = {
    promise: null
  };

  componentDidMount() {
    this.loadGame(this.props.params.gameId);
  }

  loadGame(gameId) {
    const { dao, router } = this.context;
    const { promise } = this.state;

    if (!!promise) {
      promise.cancel();
    }

    dao.games.getSingle(gameId)
      .then(
        ({ name, localDate, gameGroup, court, sides }) => router.replace(
          join(
            'tourneys',
            gameGroup.division.tourney.id,
            'games',
            toUrlData({
              filter: {
                gameGroup,
                division: gameGroup.division,
                court,
                venue: court ? court.venue : null,
                gameNameSearch: name
              }
            })
          )
        )
      )
      .finally(
        () => this.setState({ promise: null })
      );
  }

  render() {
    const { promise } = this.state;

    if (!!promise) {
      return EmptyState.LOADING;
    } else {
      return (<EmptyState>Game ID is invalid!</EmptyState>);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/GameDay/components/pages/LoadGameRedirect.jsx